import { useEffect, useState } from 'react';

/**
 * Detecta viewports donde no cabe el layout de dos columnas: teléfonos y
 * tablets en vertical, y teléfonos en horizontal (donde sobra ancho pero
 * falta altura, así que el ancho por sí solo no alcanza para decidir).
 */
const COMPACT_QUERY = '(max-width: 899px), (max-height: 559px) and (orientation: landscape)';
const LANDSCAPE_QUERY = '(orientation: landscape)';

const matches = (query) => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
};

const subscribe = (query, onChange) => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const list = window.matchMedia(query);
    const handler = (event) => onChange(event.matches);

    if (list.addEventListener) {
        list.addEventListener('change', handler);
        return () => list.removeEventListener('change', handler);
    }

    // Safari < 14
    list.addListener(handler);
    return () => list.removeListener(handler);
};

/**
 * @returns {{ isCompact: boolean, isLandscape: boolean }}
 */
export function useCompactViewport() {
    const [isCompact, setIsCompact] = useState(() => matches(COMPACT_QUERY));
    const [isLandscape, setIsLandscape] = useState(() => matches(LANDSCAPE_QUERY));

    useEffect(() => subscribe(COMPACT_QUERY, setIsCompact), []);
    useEffect(() => subscribe(LANDSCAPE_QUERY, setIsLandscape), []);

    return { isCompact, isLandscape };
}

export default useCompactViewport;
